import { render, staticRenderFns } from "./mg-video.vue?vue&type=template&id=0fcbbfe2&scoped=true&"
import script from "./mg-video.vue?vue&type=script&lang=js&"
export * from "./mg-video.vue?vue&type=script&lang=js&"
import style0 from "./mg-video.vue?vue&type=style&index=0&id=0fcbbfe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcbbfe2",
  null
  
)

export default component.exports